module.exports = __webpack_public_path__ + "img/Logo_JA.ad652048.svg";